<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row" v-if="evento">                        
            <div class="col-12 col-lg-6">
                <FormInput label="NIF*" type="text" name="nif" id="nif" rules="required" v-model="evento.nif_fiscal" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Nombre*" type="text" name="nombre" id="nombre" rules="required" v-model="evento.nombre_fiscal" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Dirección*" type="text" name="direccion" id="direccion" rules="required" v-model="evento.direccion_fiscal" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Cuenta*" type="text" name="cuenta" id="cuenta" rules="required" v-model="evento.cuenta_fiscal" />
            </div>
            <div class="col-12">
                <h4>Contacto:</h4>
                <hr>
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Email de contacto*" type="email" name="Email de contacto" id="contact_email" rules="required|email" v-model="evento.contact_email" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Teléfono de contacto*" type="text" name="Teléfono de contacto" id="contact_telefono" rules="required" v-model="evento.contact_telefono" />
            </div>
            <div class="col-12">
                <Button type="submit">Guardar</Button>
            </div>                        
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['evento'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardar();
                }
            },
            guardar() {
                const data = {
                    nif_fiscal: this.evento.nif_fiscal,
                    nombre_fiscal: this.evento.nombre_fiscal,
                    direccion_fiscal: this.evento.direccion_fiscal,
                    cuenta_fiscal: this.evento.cuenta_fiscal,
                    evento_id: this.evento.id,
                    contact_email: this.evento.contact_email,
                    contact_telefono: this.evento.contact_telefono,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.editar.datos-fiscales'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.$emit('actualizado');
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                });
            },
        }
    }
</script>